import React from "react";
import axios from "axios";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../components/CustomButtons/Button";
import DialogContent from "@mui/material/DialogContent";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import CustomInput from "../../../components/CustomInput/CustomInput";
import CustomSwitch from "../../../components/CustomInput/CustomSwitch";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import { Close } from "@mui/icons-material";
import { FormLabel } from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";

import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class AddUniqueVouchers extends React.Component {
  constructor(props) {
    //receiving props:
    //  open={this.state.addUniqueVouchersModal}
    //  toggle={() => this.toggleModal('addUniqueVouchersModal')}
    //  voucherDefIds={this.state.selectedIds}
    //  refreshTable={() => this.refreshJamezzTable()}
    super(props);
    this.state = {
      saving: false,
      numberOfVouchersToCreate: 1,
      createVouchersAsActive: false,
      createVouchersAsSingleUse: false,
      secretVoucherCodeLength: 10,
      secretVoucherCodeOnlyDigits: false,
    };
  }

  /**************************************************************************************************/
  save = () => {
    this.setState({ saving: true });

    let data = {
      voucherDefIds: this.props.voucherDefIds,
      numberOfVouchersToCreate: this.state.numberOfVouchersToCreate,
      createVouchersAsActive: this.state.createVouchersAsActive,
      createVouchersAsSingleUse: this.state.createVouchersAsSingleUse,
      secretVoucherCodeLength: this.state.secretVoucherCodeLength,
      secretVoucherCodeOnlyDigits: this.state.secretVoucherCodeOnlyDigits,
    };

    axios.post("core/voucherdefs/addUniqueVouchers", data).then((response) => {
      this.setState({ saving: false });
      this.props.refreshTable();
      this.props.toggle();
    });
  };

  /**************************************************************************************************/
  disableSave = () => {
    return this.state.numberOfVouchersToCreate === 0;
  };

  /**************************************************************************************************/
  handleNumberOfVouchersToCreate = (event) => {
    this.setState({ numberOfVouchersToCreate: event.target.value });
  };

  /**************************************************************************************************/
  handleCreateVouchersAsActive = (event) => {
    this.setState({
      createVouchersAsActive: event.target.checked,
    });
  };

  /**************************************************************************************************/
  handleCreateVouchersAsSingleUse = (event) => {
    this.setState({
      createVouchersAsSingleUse: event.target.checked,
    });
  };

  /**************************************************************************************************/
  handleSecretVoucherCodeLength = (event) => {
    this.setState({ secretVoucherCodeLength: event.target.value });
  };

  /**************************************************************************************************/
  handleSecretVoucherCodeOnlyDigits = (event) => {
    this.setState({
      secretVoucherCodeOnlyDigits: event.target.checked,
    });
  };

  /**************************************************************************************************/

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={this.props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            <TranslationWrapper
              tDefault={"Add Unique Vouchers [~]"}
              tKey={"voucherDefs.modal.addUniqueVouchers.title"}
            />
          </h4>
        </DialogTitle>
        <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
          {/**************************************************************************************************/}
          <GridContainer>
            <GridItem sm={4} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper
                  tDefault={"Number of Vouchers to create [~]"}
                  tKey={"voucherDefs.modal.addUniqueVouchers.form.numberOfVouchersToCreate"}
                />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <CustomInput
                formControlProps={{
                  fullWidth: false,
                }}
                id={"numberOfVouchersToCreate"}
                inputProps={{
                  type: "number",
                  name: "numberOfVouchersToCreate",
                  value: this.state.numberOfVouchersToCreate,
                  onChange: this.handleNumberOfVouchersToCreate,
                }}
              />
            </GridItem>
          </GridContainer>
          {/**************************************************************************************************/}
          <GridContainer>
            <GridItem lg={4}>
              <FormLabel>
                <TranslationWrapper
                  tDefault={"Create vouchers as Active [~]"}
                  tKey={"voucherDefs.modal.addUniqueVouchers.form.createVouchersAsActive"}
                />
              </FormLabel>
            </GridItem>
            <GridItem lg={8}>
              <CustomSwitch checked={this.state.createVouchersAsActive} onChange={this.handleCreateVouchersAsActive} />
            </GridItem>
          </GridContainer>
          {/**************************************************************************************************/}
          <GridContainer>
            <GridItem lg={4}>
              <FormLabel>
                <TranslationWrapper
                  tDefault={"Create Vouchers As SingleUse"}
                  tKey={"voucherDefs.modal.addUniqueVouchers.form.createVouchersAsSingleUse"}
                />
              </FormLabel>
            </GridItem>
            <GridItem lg={8}>
              <CustomSwitch
                checked={this.state.createVouchersAsSingleUse}
                onChange={this.handleCreateVouchersAsSingleUse}
              />
            </GridItem>
          </GridContainer>
          {/**************************************************************************************************/}
          <Card>
            <CardBody>
              <h5>
                <TranslationWrapper
                  tDefault={"Optional settings"}
                  tKey={"voucherDefs.modal.addUniqueVouchers.form.headerTextExtraOptions"}
                />
              </h5>
              <GridContainer>
                <GridItem sm={4} xs={12}>
                  <FormLabel className={classes.labelHorizontal}>
                    <TranslationWrapper
                      tDefault={"Length of secret code (random part)"}
                      tKey={"voucherDefs" + "." + "modal.addUniqueVouchers.form.secretVoucherCodeLength"}
                    />
                  </FormLabel>
                </GridItem>
                <GridItem sm={8} xs={12}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: false,
                    }}
                    id={"secretVoucherCodeLength"}
                    inputProps={{
                      type: "number",
                      name: "secretVoucherCodeLength",
                      value: this.state.secretVoucherCodeLength,
                      onChange: this.handleSecretVoucherCodeLength,
                    }}
                  />
                </GridItem>
              </GridContainer>
              {/**************************************************************************************************/}
              <GridContainer>
                <GridItem lg={4}>
                  <FormLabel>
                    <TranslationWrapper
                      tDefault={"Use only Digits"}
                      tKey={"voucherDefs.modal.addUniqueVouchers.form.secretVoucherCodeOnlyDigits"}
                    />
                  </FormLabel>
                </GridItem>
                <GridItem lg={8}>
                  <CustomSwitch
                    checked={this.state.secretVoucherCodeOnlyDigits}
                    onChange={this.handleSecretVoucherCodeOnlyDigits}
                  />
                </GridItem>
              </GridContainer>
              {/**************************************************************************************************/}
            </CardBody>
          </Card>
        </DialogContent>

        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          <SaveButton
            buttonText={
              <TranslationWrapper
                tDefault={"Create Vouchers"}
                tKey={"voucherDefs.modal.addUniqueVouchers.form.savebutton.text"}
              />
            }
            disabled={this.disableSave()}
            onClick={this.save}
            saving={this.state.saving}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(AddUniqueVouchers, notificationsStyle);
